import React from 'react';
import Pic1 from '../../InstallImages/Modules/REC365ALPHA';


const moduleLink = <a href="https://www.dropbox.com/s/k00zhor6x1qam64/ds_rec_alpha_black_series_rev_d2_ALPHA%20BLACK.pdf?dl=0" rel="noopener noreferrer" target="_blank">Data Sheet</a>;

const Module = () => (
    <div>
        <div className="col span-1-of-2">
            <Pic1 />
        </div>
        <div className="col span-1-of-2">
            <p className="specsText">
                This is the REC Alpha; REC&apos;s latest family of trailblazing solar panels, empowering you to take full advantage of solar energy. With 380 Wp 60-cell power, reaching 450 Wp in a 72-cell format, and impressive 217 W/m², REC Alpha delivers 20% more solar power than conventional solar panels, making it the solar panel of choice for home solar. How does REC do it and what does it mean for you?
            </p>

            <ul> <h1>Premium solar panel warranty</h1>
                <li className="specsText">    25 year product warranty*: covers panel defects</li>
                <li className="specsText">    25 year performance warranty: ensures panels perform exactly as they’re expected to – every year for 25 years</li>
                <li className="specsText">    25 year labor warranty*: gives added protection in case a panel needs to be serviced</li>
                <li className="specsText">       Unprecedented savings, more economic security, and greater energy autonomy for consumers
                </li>
                <li className="specsText">    * when installed by a REC Certified Solar Professional installer; part of the REC ProTrust Warranty
                </li>
            </ul>
            <ul> <h1>Heterojunction (HJT) cell technology</h1>
                <li className="specsText">All Black</li>
                <li className="specsText">No LID = no power loss; you get the power you pay for</li>
                <li className="specsText">Leading temperature coefficient means more energy as temperature rises</li>
                <li className="specsText">Maximum power for maximum savings and accelerated return on investment
                </li>
                <li className="specsText">Its high power density (217 watts/m²) helps to get the most from limited spaces
                </li>
                <li className="specsText">20% more power on your roof compared to conventional panels
                </li>
                <li className="specsText">{moduleLink}</li>
            </ul>
        </div>
    </div>
);


export default Module;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/Panels/rec365.js